export interface IndustryTag {
  id: string
  name: string
  descriptions: string
}
export const industryTags: IndustryTag[] = [
  {
    id: 'tag1',
    name: '航发',
    descriptions: '涡轴发动机模型、飞发一体化综合仿真等'
  },
  {
    id: 'tag2',
    name: '航空',
    descriptions: '机电液执行机构、数字孪生飞机起落架虚实融合平台等'
  },
  {
    id: 'tag3',
    name: '航天',
    descriptions: '卫星姿轨模型、无人机飞行控制与管理系统适航性测试验证等'
  },
  {
    id: 'tag4',
    name: '汽车',
    descriptions: '汽车控制应用层开发、汽车整车控制器VCU硬件在环(HiL)仿真测试和验证等'
  }
]
